import React from 'react';
import PropTypes from 'prop-types';
import { ImageConfig } from '../config/ImageConfig'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import DownloadIcon from '@mui/icons-material/Download';
import FolderOffIcon from '@mui/icons-material/FolderOff';
import Loading from './Loading'
import DropFileInput from './FileUpload';
import { apiPost } from '../api';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const getDetails = (id) => apiPost(process.env.REACT_APP_API_GET_DETAIL, { id });
const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
const downloadFile = async (id_solicitud, id_attachment, name) => {
  try {
    let solicitudes = await fetch(process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_DOWNLOAD_ATTACHMENTS, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${getCookie('asa_hd_auth')}` },
      body: JSON.stringify({
        id_solicitud: id_solicitud,
        id_attachment: id_attachment
      })
    })
    if (solicitudes.ok) {
      solicitudes.blob().then((file) => {
        const url = window.URL.createObjectURL(file,);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          name,
        );
        link.click();
      });
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

// Decide si la tab "Subir Documentacion" corresponde para este tipo de
// documentacion y estado de solicitud. Se usa tanto para el estado inicial
// como dentro del efecto, para no duplicar la regla.
const puedeSubir = (type, estado) => {
  if (type === "Técnica") return estado === "Esperando documentación técnica";
  if (type === "CAO") return estado === "Esperando CAO";
  return true;
};

export default function BasicTabs(props) {
  const estadoInicial = props.clickRow?.solicitud?.attributes?.estado;
  // Inicializar en el valor correcto (y no en 0 = tab "Subir") evita que el
  // primer render muestre el texto legal completo y el efecto lo oculte un
  // frame despues: ese parpadeo era el que provocaba el overflow horizontal.
  const subirHabilitado = puedeSubir(props.type, estadoInicial);
  const [value, setValue] = React.useState(subirHabilitado ? 0 : 1);
  const [filesArray, setFilesArray] = React.useState(0);
  const [fileList, setFileList] = React.useState([]);
  const [upload, setUpload] = React.useState(false);
  const [tabDisplay, setTabDisplay] = React.useState(subirHabilitado ? 'block' : 'none');
  const [fileDisplay, setFileDisplay] = React.useState(true);

  const handleChange = (event, newValue) => {
    if (newValue == 1) {
      props.setDisplayButtonHook('none')
    } else {
      props.setDisplayButtonHook('block')
    }
    setValue(newValue);
  };
  const onFileChange = (files) => {
    setFilesArray(files);
    props.setFiles(files);
  }
  const handleCloseUpload = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUpload(false)
  };
  const handleCloseUploadError = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    props.setUploadError(false)
  };
  React.useEffect(() => {
    if (!puedeSubir(props.type, props.clickRow?.solicitud?.attributes?.estado)) {
      setValue(1)
      props.setDisplayButtonHook('none')
      setTabDisplay('none')
    } else {
      setValue(0)
      props.setDisplayButtonHook('block')
      setTabDisplay('block')
    }

    
    if (props.ver == 1) {
      setValue(1)
      setFileDisplay(false)
      props.setDisplayButtonHook('none')
      setUpload(true)
      setTabDisplay('none')
      props.setVer(2)

    } else if (props.ver == 2) {
      setValue(1)
      setFileDisplay(false)
      props.setDisplayButtonHook('none')
      setTabDisplay('none')
    }
    if (props.clickRow) {
      setFileDisplay(false)
      getDetails(props.clickRow.solicitud.attributes.id).then(x => {
        if (x.documentos) {
          let array = []
          x.documentos.forEach(element => {
            if (props.type == element.tipo_documentacion && element.attachments.length != 0) {
              array.push(element)
            }
          });
          if (array.length == 0) setFileDisplay(true)
          setFileList(array)
        } else {
          setFileDisplay(true)
        }
      }).catch(() => {
        // Sin catch el spinner quedaba girando para siempre si fallaba la
        // consulta. Mostramos el estado vacio, que es lo unico que podemos
        // afirmar; si la sesion vencio, api.js ya redirige al login.
        setFileDisplay(true)
      })
    }

    // props.type y el estado de la solicitud tienen que estar en las
    // dependencias: al cambiar de seccion en el rail, UploadDocuments reusa
    // esta misma instancia de Upload y solo cambia props.type. Con [props.ver]
    // solo, el efecto no volvia a correr si ver ya valia false, y tabDisplay
    // quedaba con lo calculado para la seccion anterior — de ahi que la tab
    // "Subir Documentacion" apareciera o no para la misma solicitud segun por
    // que seccion hubieras pasado antes.
  }, [props.ver, props.type, props.clickRow?.solicitud?.attributes?.estado, props.clickRow?.solicitud?.attributes?.id]);
  return (
    // Sin height:100%: el contenedor padre scrollea, asi que fijar el alto al
    // del area visible hacia que el texto largo se desbordara del Box en vez de
    // estirarlo — y el footer, que va despues, quedaba a mitad del texto.
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
          <Tab label="Subir Documentacion" {...a11yProps(0)} style={{ display: tabDisplay }} />
          <Tab label="Ver Documentacion" {...a11yProps(1)} />
        </Tabs>
      </Box>
      {/* subir */}
      <TabPanel value={value} index={0}>
        {props.type == "Técnica" ? <div style={{ marginBottom: "30px", }}>
          <p>En el marco del RTDHL Reglamento T&eacute;cnico para ductos de Hidrocarburos L&iacute;quidos &ndash; Resoluci&oacute;n 120 &ndash; E &ndash; 2017 aprobado por la Secretar&iacute;a de Energ&iacute;a del Gobierno de la Naci&oacute;n ( Anexo Capitulo XI, ap&eacute;ndice N1-N9 ), para trabajar en la zona de la FS franja de seguridad de los Oleoductos, debe realizarse la gesti&oacute;n previa de autorizaci&oacute;n para el cumplimiento de los requisitos de documentaci&oacute;n t&eacute;cnica y requisitos de seguridad.</p>

          <p>Para realizar trabajos dentro de la zona de FS franja de seguridad de los Oleoductos ( 7,50 metros a cada lado del eje de cada ducto), tareas que involucre movimientos de suelos o circulaci&oacute;n de equipos sobre los ductos, se deber&aacute; presentar documentaci&oacute;n previo a la autorizaci&oacute;n de los trabajos.</p>

          <p></p>

          <p>En el proceso de la gesti&oacute;n de Interferencias y relacionado con la documentaci&oacute;n y requisitos t&eacute;cnicos se deber&aacute; presentar para su validaci&oacute;n:</p>
          <ul>
            <li>Nota de solicitud de Interferencias de la nueva instalaci&oacute;n planificada.</li>
            <li>Memoria t&eacute;cnica descriptiva relacionado con todas las tareas a realizar en la nueva instalaci&oacute;n, indicando las coordenadas geogr&aacute;ficas del sitio de cruce.</li>
            <li>Plano de ubicaci&oacute;n general.</li>
            <li>Planos constructivos de detalles.</li>
            <li>Procedimientos operativos de los trabajos previstos.</li>
            <li>Cronograma y fecha estimada de ejecuci&oacute;n de las tareas.</li>
          </ul>

          <p>Se adjunta documentaci&oacute;n asociada al tratamiento de las interferencias (Gu&iacute;a gesti&oacute;n de interferencias y Documento PO_OL_IND_03 Cruces e Interferencias, punto 5.1 al 5.3 &ndash; hoja 6 a 9).</p>

          <p>En el RTDHL indicado, Anexo apartado punto 403.8.7 - Cruce con ca&ntilde;er&iacute;as y servicios p&uacute;blicos, se establece el procedimiento conceptual a considerar para el cruce de nuevas instalaciones, el mismo se ejecutar&aacute; por debajo de la instalaci&oacute;n existente, con una separaci&oacute;n libre m&iacute;nima de 0,50 metros.</p>

          <p></p>

          <p>Para coordinar la realizaci&oacute;n de los cateos manuales, tareas previas a los trabajos de zanjeo mec&aacute;nico o circulaciones de equipos, se deber&aacute; contactar al Supervisor operativo de OLDELVAL de la zona geogr&aacute;fica del cruce a realizar.</p>

          <p>Se debe realizar en forma anticipada la se&ntilde;alizaci&oacute;n de la traza en el terreno y la medici&oacute;n de la tapada estimada medida con equipo electromagn&eacute;tico.</p>

          <p></p>

          <p>Se deber&aacute; dar cumplimiento a lo indicado en el Anexo 2.</p>

          <p>Anexo 2. FICHA TECNICA</p>
          <ol>
            <li>Gestionar las habilitaciones que correspondan a las tareas a realizar para permitir la Supervisi&oacute;n de OLDELVAL S.A. antes de iniciar los trabajos.</li>
            <li>Avisar a OLDELVAL S.A. con tres d&iacute;as de anticipaci&oacute;n a la fecha real de iniciaci&oacute;n de los trabajos.</li>
            <li>Delimitaci&oacute;n del &aacute;rea de trabajo e instalar carteler&iacute;a apropiada que indique la prohibici&oacute;n de ingreso de personas ajenas a la obra.</li>
            <li>Verificaci&oacute;n de la tapada del Oleoducto y realizaci&oacute;n de cateos previos con herramientas manuales. (en coordinaci&oacute;n con el supervisor de OLDELVAL)</li>
            <li>Ninguna maquina vial podr&aacute; acercarse a menos de dos (2) metros con relaci&oacute;n al eje del Oleoducto.</li>
            <li>La distancia m&iacute;nima de seguridad con el Oleoducto es de 7,50 metros a ambos lados del eje de la ca&ntilde;er&iacute;a (FS franja de seguridad).</li>
            <li>No se podr&aacute; efectuar trabajos en cercan&iacute;as al Oleoducto operado por OLDELVAL S.A. sin la presencia de un Supervisor autorizado.</li>
            <li>Los trabajos se realizar&aacute;n entre las 8 y las 17 hs de lunes a viernes en d&iacute;as h&aacute;biles.</li>
            <li>Se deber&aacute; respetar las directivas impartidas por la Inspecci&oacute;n de OLDELVAL S.A. en lo referente a Medio Ambiente, Seguridad y condiciones particulares de acuerdo a la zona de trabajo.</li>
            <li>Se deber&aacute; emitir reporte final de las actividades realizadas, acompa&ntilde;ado de plano CAO conforme a obra y algunas fotos relevantes.</li>
            <li>Se deber&aacute; colocar en la zona cercana a la interferencia, un cartel indicativo de la existencia de la interferencia.</li>
            <li>En ning&uacute;n caso se deber&aacute; realizar excavaciones en el punto de interferencia sin la presencia y supervisi&oacute;n directa de OLDELVAL S.A.</li>
          </ol>
        </div> : null}
        <div>
          <p style={{fontSize: "17px"}}>Formato de archivos compatibles:<br></br><b style={{color: "red"}}>Para cargar archivos KMZ o KML u otro formato no valido, por favor súbalo en un archivo comprimido ZIP o 7Z</b></p>

          <p style={{fontSize: "12px"}} >7Z, AIF, AVI, BMP, CSV, DOC, DOCX, DOT, ECW, EMF, EPS, GEOJSON, GIF, GML, GPKG, GTAR, GZ, IMG, J2K, JP2, JPC, JPE, JPEG, JPF, JPG, JSON, M4A, MDB, MID, MOV, MP2, MP3, MP4, MPA, MPE, MPEG, MPG, MPV2, PDF, PNG, PPT, PPTX, PS, PSD, QT, RA, RAM, RAW, RMI, SID, TAR, TGZ, TIF, TIFF, TXT, VRML, WAV, WMA, WMF, WMV, WPS, XLS, XLSX, XLT, XML, ZIP.</p>
        </div>
        <DropFileInput
          onFileChange={(files) => onFileChange(files)}
          files={filesArray}
        />
        <Snackbar open={props.uploadError} autoHideDuration={6000} onClose={handleCloseUploadError}>
          <Alert onClose={handleCloseUploadError} severity="error" sx={{ width: '100%', zIndex: '6000' }}>
            Error al cargar el archivo adjunto, tamaño o tipo de archivo no admitido
          </Alert>
        </Snackbar>
      </TabPanel>
      {/* ver */}
      <TabPanel value={value} index={1} border={'none'}>
        {/* fileDisplay en true = la consulta termino y no hay documentos de
            este tipo. Antes se renderizaba null y la tab quedaba en blanco. */}
        {fileDisplay ?
          <div className="ds-empty-state">
            <FolderOffIcon className="ds-empty-state__icon" />
            <p className="ds-empty-state__title">No hay documentación cargada aún</p>
            <p className="ds-empty-state__desc">
              Los archivos que subas van a aparecer acá.
            </p>
          </div>
          :
          <div>
            {
              fileList.length > 0 ? (
                <div className="drop-file-preview">
                  {
                    fileList.map((item, index) => (
                      <div key={index} className="drop-file-preview__item">
                        {item.attachments.length != 0 ? <><img src={ImageConfig[item.attachments[0].content_type.split('/')[1]] || ImageConfig['default']} alt="" />
                          <div className="drop-file-preview__item__info">
                            <p style={{ margin: '0px' }}>{item.attachments[0].name}</p>

                          </div>
                          <span className="drop-file-preview__item__del" onClick={() => downloadFile(item.id_solicitud, item.attachments[0].id, item.attachments[0].name)}><DownloadIcon style={{ fontSize: '15px' }} /></span>
                        </>
                          : null}
                      </div>
                    ))
                  }
                </div>
              ) : <Loading color={"transparent"} height={"100%"} width={"90%"} />
            }
          </div>
        }
        <Snackbar open={upload} autoHideDuration={6000} onClose={handleCloseUpload}>
          <Alert onClose={handleCloseUpload} severity="success" sx={{ width: '100%', zIndex: '6000' }}>
            Se ha cargado la documentacion correctamente
          </Alert>
        </Snackbar>
      </TabPanel>
    </Box>
  );
}
